import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {
   persistStore,
   persistReducer,
   FLUSH,
   REHYDRATE,
   PAUSE,
   PERSIST,
   PURGE,
   REGISTER,
} from 'redux-persist';

import {apiSlice} from "./apiSlice/apiSlice";
import authReducer from "../features/auth-slice";
import candidateReducer from "../features/candidate-slice";
import filterReducer from "../features/filter-slice";

import storage from 'redux-persist/lib/storage';

const persistConfig = {
   key: 'auth',
   version: 1,
   storage,
   whitelist: [
      'AuthReducer',
      'CandidateReducer',
      'FilterReducer'
   ],
};

const rootReducer = combineReducers({
   AuthReducer: authReducer,
   CandidateReducer: candidateReducer,
   FilterReducer: filterReducer,
   [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
   reducer: persistedReducer,
   middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
         serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
         },
      }).concat(apiSlice.middleware),
   devTools: true,
})

export const persistor = persistStore(store);
